import { render, staticRenderFns } from "./User-phone-edit.vue?vue&type=template&id=5607db64&scoped=true&"
import script from "./User-phone-edit.vue?vue&type=script&lang=js&"
export * from "./User-phone-edit.vue?vue&type=script&lang=js&"
import style0 from "./User-phone-edit.vue?vue&type=style&index=0&id=5607db64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5607db64",
  null
  
)

export default component.exports